import { useOktaAuth } from "@okta/okta-react";
import { Button } from "antd";
import { signOut } from "@aws-amplify/auth";
import { useHistory } from "react-router-dom";

const Header = ({ children }) => {
  const { oktaAuth } = useOktaAuth();
  const accessTokenCognito = localStorage.getItem("accessToken");

  const history = useHistory();

  const handleLogoutOKTA = async () => {
    await oktaAuth.signOut();
    localStorage.removeItem("loggedInAs");
    localStorage.removeItem("okta-token-storage");
    localStorage.removeItem("okta-cache-storage"); 
    localStorage.removeItem("okta-shared-transaction-storage");
    localStorage.removeItem("okta-original-uri-storage");
  };

  const handlelogoutForCognito = async () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("loggedInAs");
    localStorage.removeItem("okta-token-storage");
    await signOut({ oauth: { global: true } });
    history.push("/");
  };

  return (
    <>
      {accessTokenCognito !== null ? (
        <div className="p-3 w-100 d-flex justify-content-end">
          <Button type="primary" danger onClick={handlelogoutForCognito}>
            Logout
          </Button>
        </div>
      ) : (
        <div className="p-3 w-100 d-flex justify-content-end">
          <Button type="primary" danger onClick={handleLogoutOKTA}>
            Logout
          </Button>
        </div>
      )}
      {children}
    </>
  );
};

export default Header;
